import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Navigation } from 'swiper/modules';

import Header from "../components/header";
import Footer from "../components/footer";

import club01 from "../assets/images/Homepages/Club-soluna.png"
import club02 from "../assets/images/Homepages/fitness.png"
import club03 from "../assets/images/Homepages/golf.png"
import club04 from "../assets/images/Homepages/library.png"


import banners01 from "../assets/images/Hospitality/1.webp"
import banners02 from "../assets/images/Hospitality/2.webp"
import banners03 from "../assets/images/Hospitality/3.webp"


import inspiration from "../assets/images/img/BIOMEHOSPITALITY/page14/background.png"

import hospitality01 from "../assets/images/img/BIOMEHOSPITALITY/page13/Ecosystem.png"
import hospitality02 from "../assets/images/img/BIOMEHOSPITALITY/page13/Food-drink.png"
import hospitality03 from "../assets/images/img/BIOMEHOSPITALITY/page13/Guest-room.png"
import hospitality04 from "../assets/images/img/BIOMEHOSPITALITY/page13/tovels.png"

import resort01 from "../assets/images/newimage/HOSPITALITY/1.png"
import resort02 from "../assets/images/newimage/HOSPITALITY/4.png"
import resort03 from "../assets/images/newimage/HOSPITALITY/3.png"
import resort04 from "../assets/images/newimage/HOSPITALITY/7.png"

import property from "../assets/images/img/Revara.png"

import page21 from "../assets/images/img/BIOMEHOSPITALITY/page21/RESIDENCE-DEVELOPMENT-CONCEPT.png"
import page22 from "../assets/images/img/BIOMEHOSPITALITY/page22/BRANDED-RESIDENCE-DEVELOPMENT.png"
import page23 from "../assets/images/img/BIOMEHOSPITALITY/page23/background.png"

import page24 from "../assets/images/img/BIOMEHOSPITALITY/page21/background.png"

import contract03 from "../assets/images/img/BIOMEHOSPITALITY/page23/INVESTMENT-REQUIRED-BY-THE-DEVELOPER.png"
import contract02 from "../assets/images/img/BIOMEHOSPITALITY/page23/KEY-INVESTMENT-HIGHLIGHTS.png"
import contract01 from "../assets/images/img/BIOMEHOSPITALITY/page23/MANAGEMENT-CONTRACT-MODEL.png"

const Contracts = [
    {
    src:contract01,
    title: "Management Contract Model",  
    desription: "Under this model, the Owner/Developer assumes full responsibility for constructing the entire project and obtaining all necessary approvals for building and operating the club/resort, executing development per precise specifications. The hotel group provides comprehensive technical assistance on design, construction, and equipment during development and construction phases; supports pre-opening activities including staff training, sales & distribution strategies, and financial training; and grants access to its established sales & marketing systems, IT infrastructure, distribution channels, and global reservation networks ensuring seamless execution, professional launch, and sustained operational excellence."
    },
//     {
//     src:contract02,
//  title: "Investment Highlights Buyers",  
//  desription:[
//     "Ownership of Freehold property",
//     "Opportunity to be a part of RentalPool program",
//     "Investment with commercial returns",
//     "21 days free stay annually",
//     "No maintenance cost",
//     "30% of room revenue only as annual yield",
//     "Capital Appreciation",
//  ]
//     },
//     {
//     src:contract03,
//  title: "Investment Required By The Developer",  
//   desription:[
//     "Initial Investment required to buy land",
//     "Funds to obtain initial approvals(land has commercial approvals)",
//     "Construction activity to be performed in 3 years",
//     "Technical Fee to Development Manager",
//     "Marketing related activities",
//     "Advances to Architect, Consultants and PMC",
//     "Site Office",
//     "Travel & Accommodation etc",
//   ]
//     },
]
const Resorts = [
    {src:resort01},
    {src:resort02},
    {src:resort03},
    {src:resort04},
]


const HospitalitiesLeft = [
    {src:hospitality01},
    {src:hospitality02},
]

const HospitalitiesRight = [
    {src:hospitality03},
    {src:hospitality04},
]


const Clubsolunas = [
    {src:club01},
    {src:club02},
    {src:club03},
    {src:club04},
]



// const banners = [
//     {src:banners01},
//     {src:banners02},
//     {src:banners03},
// ]


const pages= [
    {
        src:page21,
        // title: "Branded Residence Development Concept",
        // desription:"Imagine a private villa sanctuary set within a living agroforestry landscape custom-built residences where nature, design, and prestige converge. At Club Soluna, ownership is reimagined through a seamless partnership with a world-class hotel group."
    },
     {
        src:page22,
        // title: "Branded Residence Development Concept",
        // desription:"Through a proven sale-and-leaseback model, owners unlock immediate capital while preserving personal usage rights. Each villa is leased to a dedicated Operating Company (OpCo), which manages hospitality operations, owns and curates all shared spaces, and delivers consistent, hotel-grade excellence."
     },
    {
        src:page23,
        // title: "Branded Residence Development Concept",
        // desription:"Returns flow effortlessly targeting 8 12% annual yields, drawn from an industry-standard 30% share of room revenues, alongside 15 21 complimentary nights of refined living each year. Concierge service, meticulous maintenance, and curated community experiences ensure ownership remains both effortless and enriching."
    }
]
  
 


export default function Hospitality() {
    return(
  <div className="dody-container">
    <Header />
    <section>
        <div className='biome biome-687'>


            <div className="biome biome-24">
                <div className="biome-element biome-element-9f59259 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky"
                    style={{ backgroundImage: `url(${inspiration})` }}>
                    <div className="e-con-inner">
                        <div
                            className="biome-element biome-element-809d30a e-con-full e-flex e-con e-child section-scroll-animation animate-section-trigger">

                            <div
                                className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h2 className="biome-heading-title biome-size-default animation__char_come attr-text-white gsap-text text-center light-green-color"
                                        data-anim="rotate">Our Inspiration</h2>
                                </div>
                            </div>

                            <div
                                className="biome-element biome-element-179e7f8 biome-widget biome-widget-heading animated fadeInUp ">
                                <div className="biome-widget-container">
                                    <h4 data-anim="rotate"
                                        className="biome-heading-title attr-text-white biome-size-default animation__char_come  text-center gsap-text">
                                        Pioneering Sustainable Luxury Living
                                    </h4>
                                </div>
                            </div>

                            <div
                                className="biome-element biome-element-a35151e biome-widget biome-widget-text-editor animated fadeInUp">
                                <div className="biome-widget-container">
                                    <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                        To create the Best & Largest Luxury Serviced Residences Project with the Most Innovative Design & Concept. These majestic luxury villas, nestled amid nature's rustic embrace, stand as a testament to our commitment to unforgettable, earth friendly spaces. Unparalleled sophistication, functionality, comfort, and style harmonize in boutique designs crafted from raw materials sourced locally powered by sustainable practices like energy efficient systems, water conservation, and regenerative landscapes.
                                    </p>

                                     <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                      We go above and beyond to deliver an unrivalled luxury experience. Each owner enjoys the privilege of their own villa on an 11,800 sq ft plot,exuding elegance and opulence. Plots feature thriving food forests and timber rich agroforestry, yielding fresh produce and sustainable wood. The enchanting landscape adorned with gazebos, inviting fire pits, a serene water pit, and an aesthetic entrance gateblends exotic flora and fauna into a vibrant tapestry of colors and scents, capturing the site's rustic soul.
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div
                className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white section-scroll-animation green-background-12 hospitalities">
                <div className="e-con--inner animate-section-trigger">
                    <div className="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child">

                        <div className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child">

                            <div
                                className="biome-element biome-element-378177c  biome-widget biome-widget-image">

                                <Swiper loop={true} autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        }} slidesPerView="auto" allowTouchMove={true} modules={[ Autoplay]}>

                                    {HospitalitiesLeft.map((hospitality, index) => (
                                    <SwiperSlide>
                                        <div className="biome-widget-container">
                                            <img decoding="async" key={index} width="960" height="640"
                                                src={hospitality.src}
                                                className="attachment-full size-full wp-image-729 wp-image-122-top"
                                                alt={hospitality.src} />
                                        </div>

                                    </SwiperSlide>
                                    ))}

                                </Swiper>

                            </div>

                        </div>

                        <div
                            className="biome-element biome-element-bb60c9b e-con-full e-flex e-con e-child hospitalities">
                            <div
                                className="biome-element biome-element-42c32f0 biome-widget biome-widget-text-editor animated ">
                                <div className="biome-widget-container">
                                    <h2 data-anim="fade-up" className='title-anim attr-text-white gsap-text'>
                                        Hospitality Overview
                                    </h2>
                                </div>
                            </div>
                            <div className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                <div className="biome-widget-container">

                                    <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>
                                       Nestled in pristine natural splendour, The Club Soluna harmonizes a curated eco community with the vibrant energies of like minded explorers, crafting joyful, rejuvenating escapes in perfect harmony with nature. Club Soluna unfolds as a symphony of sustainable elegance a curated haven where visionary Eco practices dance with bespoke luxury. Savor farm to table delights, artisanal drinks, sustainable amenities, heartfelt service, and warmth at The Club Soluna to elevate your green getaway. Tailored for every adventurer family, friend filled Eco trails, colleague retreats in lush parks, or serene spa unwinding amid biodiverse hotspots. Thoughtfully designed for wholesome, low impact luxury, with in house games and nature inspired activities your gateway to responsible eco tourism bliss.
                                    </p>
{/* 
                                    <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>Complemented
                                        by great food and beverages, premium amenities, warm hospitality, and
                                        exceptional service, The Biome is designed to complete your experience. There is
                                        something here for everyone   whether you wish to enjoy an activity-filled day
                                        with family, friends, or colleagues, or simply unwind and relax at the spa, or
                                        spend the day exploring the surrounding national parks.
                                    </p>
                                    <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>All
                                        amenities at The Biome are thoughtfully considered and crafted to ensure a
                                        wholesome and complete experience.</p>
                                    <p data-anim="fade-up" className='title-anim attr-text-white gsap-text'>We take
                                        pride in offering a wide range of in-house games and engaging activities during
                                        your stay, all of which you will find listed inside.</p> */}
                                </div>
                            </div>

                        </div>

                        <div className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child">

                            <div
                                className="biome-element biome-element-378177c  biome-widget biome-widget-image">

                                <Swiper loop={true} autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        }} slidesPerView="auto" allowTouchMove={true} modules={[ Autoplay]}>

                                    {HospitalitiesRight.map((hospitality, index) => (
                                    <SwiperSlide>
                                        <div className="biome-widget-container">
                                            <img decoding="async" key={index} width="960" height="640"
                                                src={hospitality.src}
                                                className="attachment-full size-full wp-image-729 wp-image-122-top"
                                                alt={hospitality.src} />
                                        </div>

                                    </SwiperSlide>
                                    ))}

                                </Swiper>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
           
              <div
                className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded horizontal-container-panel ">

                <div className="biome-background-slideshow section-scroll-animation">
                    <Swiper loop={true} autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        }} slidesPerView="auto" allowTouchMove={true} modules={[ Autoplay]}>
                        {Clubsolunas.map((Clubsoluna, i) => (
                        <SwiperSlide>
                            <div className="biome-background-slideshow__slide">
                                <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                    style={{ backgroundImage: `url(${Clubsoluna.src})` }}>
                                </div>
                            </div>
                        </SwiperSlide>
                        ))}
                    </Swiper>

                </div>

                <div className="e-con-inner animate-section-trigger">
                    <div
                        className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading animated fadeInUp">
                        <div className="biome-widget-container">
                            <h2 data-anim="rotate" className="biome-heading-title gsap-text biome-size-default">Club
                                Soluna.A Refuge Tailored to You, Shaped by Nature</h2>
                        </div>
                    </div>
                    <div className="biome-element biome-element-48776fe e-con-full e-flex e-con e-child"
                        data-id="48776fe" data-element_type="container">
                        <div
                            className="biome-element biome-element-b750a21 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">

                                <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                    This is the heart of our community, a retreat woven into the earth’s quiet rhythm. A
                                    space where solitude and nature entwine, Club Soluna is your sanctuary for wellness,
                                    connection, and play.
                                </p>
                            </div>
                        </div>
                        <div
                            className="biome-element biome-element-65874f3 biome-view-framed biome-widget__width-initial biome-widget-mobile__width-inherit biome-shape-circle biome-widget biome-widget-icon animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="biome-icon-wrapper">
                                    <a className="biome-icon" href="/amenities">
                                        <i aria-hidden="true" className="icon icon-right-arrow"></i> </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                 <div className="biome biome-24 brandedresidence">

            <div className="swiper-controls-icons swiper-controls"> <button className="swiper-prev-icon"><svg
                        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                    </svg></button> <button className="swiper-next-icon"><svg xmlns="http://www.w3.org/2000/svg"
                        width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></button></div>
                        <Swiper loop={true}
                                    allowTouchMove={true} navigation={{
                                        prevEl: ".swiper-prev-icon",
                                        nextEl: ".swiper-next-icon",
                                }} modules={[Navigation, Autoplay]} autoplay={{ delay: 2500, disableOnInteraction: false }} spaceBetween={24} slidesPerView={3} breakpoints={{
                    0: {
                    slidesPerView: 1,   
                    spaceBetween: 12,
                    },
                    640: {
                    slidesPerView: 1, 
                    spaceBetween: 16,
                    },
                    1024: {
                    slidesPerView: 1,  
                    spaceBetween: 24,
                    },
                }}>
                {pages.map((page, i) => (
                <SwiperSlide>
                    <div key={i} className="biome-element biome-element-9f59259 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky"
                        style={{ backgroundImage: `url(${page.src})` }}>
                        <div className="e-con-inner">
                            <div
                                className="biome-element biome-element-809d30a e-con-full e-flex e-con e-child section-scroll-animation animate-section-trigger">

                                <div
                                    className="biome-element biome-element-179e7f8 biome-widget biome-widget-heading animated fadeInUp ">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="biome-heading-title biome-size-default animation__char_come attr-text-white gsap-text text-center">
                                            Branded Residence 
                                        </h2>
                                    </div>
                                </div>

                                <div
                                    className="biome-element biome-element-a35151e biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                        Imagine a private villa sanctuary set within a living agroforestry landscape custom built residences where nature, design, and prestige converge. At Club Soluna, ownership is reimagined through a seamless partnership with a world class hotel group.
                                        </p>
                                         <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                           Through a proven sale-and-leaseback model, owners unlock immediate capital while preserving personal usage rights. Each villa is leased to a dedicated Operating Company (OpCo), which manages hospitality operations, owns and curates all shared spaces, and delivers consistent, hotel grade excellence.
                                        </p>
                                         <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                        Returns flow effortlessly targeting 8 to 12% annual yields, drawn from an industry standard 30% share of room revenues, alongside 15 to 21 complimentary nights of refined living each year. Concierge service, meticulous maintenance, and curated community experiences ensure ownership remains both effortless and enriching.
                                        </p>
                                         <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                        Within a streamlined 3 year development journey, 50 bespoke villas, each enthroned on 11,800 sq ft  is transformed into a branded residence of enduring value combining financial confidence, long term appreciation, and the rare privilege of belonging to a sustainable paradise.
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </SwiperSlide>
                ))}
            </Swiper> 
        </div>

            <div className="biome biome-24 ">
                <div
                    className="biome-element biome-element-1447961 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white animate-section-trigger">
                    <div className="e-con-inner">
                        <div
                            className="biome-element biome-element-b184175 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title ">Resort And
                                            Residences</h2>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div
                            className="biome-element biome-element-b184175 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">

                                    <p data-anim="fade-up" className="title-anim gsap-text">Built with stabilised mud
                                        blocks, rammed earth walls, and local stone, nestings use on site materials for
                                        low embodied energy and natural insulation. Courtyards and shaded verandahs
                                        create microclimates, while green roofs blend roofs into the surrounding canopy,
                                        supporting biodiversity and cooling the interiors.</p>
                                </div>
                            </div>
                              
                        </div>
                      
                        <div className="biome-element biome-element-e375d20 e-con-full e-flex e-con e-child">
                            {Resorts.map((resort, index) => (

                            <div className="biome-element biome-element-3012ab4 e-con-full e-flex e-con e-child animated fadeInUp"
                                key={index} style={{ backgroundImage: `url(${resort.src})` }}>

                            </div>
                            ))}
                        </div>
  <div className="biome-button-wrapper text-center">
                                    <a className="biome-button biome-button-link biome-size-sm" href="/fieldhouse">
                                        <span className="biome-button-content-wrapper">
                                        <span className="biome-button-text  animation__char_come gsap-text attr-text-white">Explore More</span><span className="biome-button-icon attr-text-white"><i aria-hidden="true" className="icon icon-right-arrow"></i></span>
                                        </span>
                                    </a>
                                </div>
                    </div>
                </div>
            </div>
        </div>

   

        <div className="biome biome-24 biome-contracts">

            <div class="biome-element biome-element-9f59259 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-element-cover-craft"
                style={{ backgroundImage: `url(${page24})` }}>
                <div class="e-con-inner">
                    {Contracts.map((contract, i) => (
                    <div class="biome-element biome-element-809d30a">
                        <div class="biome-widget-image">
                            <div class="biome-widget-container">
                                <img loading="lazy" decoding="async" width="600" height="720" src={contract.src}
                                    class="attachment-full size-full wp-image-137" alt={contract.src} />
                            </div>
                        </div>
                        <div class=" biome-widget-heading">
                            <div class="biome-widget-container">
                                <h4 class="biome-heading-title biome-size-default">{contract.title}</h4>
                            </div>
                        </div>
                        <div class="biome-widget-description">
                            <div class="biome-widget-container">
                                <p data-anim="fade-up" className='title-anim gsap-text'>
                                    {contract.desription}
                                </p>
                            </div>
                        </div>

                    </div>
                    ))}
                </div>
            </div>

        </div>
          <div className='biome biome-687'>

            <div
                className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white section-scroll-animation hospitalities">
                <div className="e-con-inner animate-section-trigger">
                    <div className="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child">

                        <div className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child">

                            <div
                                className="biome-element biome-element-378177c  biome-widget biome-widget-image bdFadeUp">

                                <div className="biome-widget-container">
                                    <img decoding="async" width="960" height="640" src={property}
                                        className="attachment-full size-full wp-image-729 wp-image-122-top"
                                        alt={property} />
                                </div>

                            </div>

                        </div>

                        <div
                            className="biome-element biome-element-bb60c9b e-con-full e-flex e-con e-child hospitalities">
                            <div
                                className="biome-element biome-element-42c32f0 biome-widget biome-widget-text-editor animated ">
                                <div className="biome-widget-container">
                                    <h2 data-anim="fade-up" className='title-anim gsap-text'>
                                        Living Lightly, Together
                                    </h2>
                                </div>
                            </div>
                            <div className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                <div className="biome-widget-container">

                                    <p data-anim="fade-up" className='title-anim gsap-text'>
                                        A central agency takes care of all aspects of managing, security, maintenance,
                                        agriculture etc also leading to reduced costs per unit due to economies of
                                        scale. One can also make use of the recreational centre and other amenities,
                                        experiences and events, also leading to the creation of a vibrant community
                                    </p>

                                    <p data-anim="fade-up" className='title-anim gsap-text'>
                                        A dedicated stewardship team nurtures every layer of life here from protecting
                                        the land and maintaining natural systems to cultivating regenerative farms and
                                        forest rooted infrastructure. This same collective also supports you with
                                        farmhouse design and construction, rental and hospitality management, and
                                        long term property care offering a seamless path to forest living. By sharing
                                        services and responsibilities, each nest becomes lighter to hold. Costs come
                                        down. Connection goes up.
                                    </p>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
          </div>
    </section>
    <Footer />
</div>
           
)}